<script>
export default {
	data() {
		return {
			errorMsg: null,
			touched: false,
			input: {
				valid: false
			}
		};
	},
	computed: {
		errorMessage() {
			return this.touched ? this.errorMsg : null;
		}
	},
	created() {
		this.findParentForm = () => {
			for (let comp = this.$parent; comp; comp = comp.$parent) {
				if (comp.$options.name === "Form")
					return comp;
			}

			return null;
		};

		this.validate();
	},
	mounted() {
		const form = this.findParentForm();

		if (form) {
			form.inputs[this._uid] = this.input;
			form.inputs = { ...form.inputs };
		}

		this.$el.addEventListener("focusout", this.touch);
	},
	beforeDestroy() {
		const form = this.findParentForm();

		if (form) {
			delete form.inputs[this._uid];
			form.inputs = { ...form.inputs };
		}

		this.$el.removeEventListener("focusout", this.touch);
	},
	methods: {
		validate() {
			this.errorMsg = this._validate();
			this.input.valid = this.errorMsg === null;
		},
		touch() {
			this.touched = true;
		}
	}
};
</script>
